import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OperationType, ROUTE_PATH, USER_TYPE } from 'common/constants/sm-constants';
import { RouteEnvelope, WidgetModel } from 'common/models/utility-models/base-model';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageService } from './storage.service';
import * as XLSX from 'xlsx';
import { AuthenticationService } from './authentication.service';
import { SafePipe } from 'common/pipes/safe.pipe';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { TokenService } from './get-token.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { LogoutService } from './logout.service';
@Injectable({
    providedIn: 'root'
})
export class SystemService {
    today = new Date();
    assignmentId: string = '';
    companyId: string = '';
    student_id: string = '';
    companyName: string = '';
    slotId: string = '';
    contentType: string = '';
    underMaintenance: boolean = false;

    dataStorage = {
        branchCategory: [],
        name: [],
        zone_name: [],
        zones: [],
        batch_number: [],
        cityName: [],
        type_name: [],
        department_name: [],
        category_name: [],
        state_List: [],
        package_list: [],
        branch_list: [],
        document_type: [],
        trainer: [],
        student: [],
        group_name: [],
        students: []
    }

    private _isAlumniProfileUpdated$ = new BehaviorSubject<boolean>(false);
    isAlumniProfileUpdated$ = this._isAlumniProfileUpdated$.asObservable()

    private sessionTimeout: BehaviorSubject<any[]> = new BehaviorSubject<any>(null);
    public sessionTimeout$: Observable<any[]> = this.sessionTimeout.asObservable();
    public sidebarActiveIndex: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public sidebarActiveIndex$: Observable<any[]> = this.sidebarActiveIndex.asObservable();
    userInfo = {
        username: '',
        password: '',
        userToken: '',
        role: ''
    };

    constructor(
        public router: Router,
        private toastr: ToastrService,
        private storageService: StorageService,
        private authService: AuthenticationService,
        // public modalService: NgbModal
        private tokenService: TokenService,
        public safePipe: SafePipe,
        public modalService: NgbModal,
        private logoutService: LogoutService
    ) { }

    setlocalStorage(key, value) {
        // console.log(key,value);

        localStorage.setItem(key, value);
    }

    getlocalStorage(key) {
        return localStorage.getItem(key);
    }

    formatTime(
        timeString: string,
        currentFormat: string,
        convertFormat: string = "hh:mm A"
    ) {
        return moment(timeString, currentFormat).format(convertFormat);
    }

    removelocalStorage(key) {
        localStorage.removeItem(key);
    }

    clearLocalStorage() {
        localStorage.clear();
    }

    setSessionStorage(key, value) {
        sessionStorage.setItem(key, value);
    }

    getSessionStorage(key) {
        return sessionStorage.getItem(key);
    }

    removeSessionStorage(key) {
        sessionStorage.removeItem(key);
    }

    clearSessionStorage() {
        sessionStorage.clear();
    }


    encryptKey(key) {
        return this.storageService.encrypt(key);
    }

    encryptUTF8(value: any) {
        return this.storageService.encryptUTF8(value);
    }

    getDecryptedValue(key: string) {
        return this.storageService.decrypt(this.getlocalStorage(key));
    }

    // decryptUTF8(value: any) {
    //     return this.storageService.decryptUTF8(value);
    // }

    showSuccess(msg: string = 'Success') {
        this.toastr.success(msg);
    }

    showInfo(msg: string = 'Information') {
        this.toastr.info(msg);
    }

    showError(msg: string = 'Error') {
        this.toastr.error(msg);
    }

    showWarning(msg: string = 'Warning') {
        this.toastr.warning(msg);
    }

    reloadPage() {
        window.location.reload();
    }

    returnFormattedDate(Data) {
        var a = new Date(Data * 1000);
        var year = a.getFullYear();
        var month = a.getMonth() + 1;
        var date = a.getDate();

        var stringDate: string = String(date);
        var stringMonth: string = String(month);
        stringDate = date < 10 ? "0" + stringDate : stringDate;
        stringMonth = month < 10 ? "0" + stringMonth : stringMonth;
        var time =
            stringDate +
            "-" +
            stringMonth +
            "-" +
            year +
            " " +
            this.formatAMPM(new Date(Data * 1000));
        return time;
    }

    formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
    }



    // navigateByUrl(url, message: RouteEnvelope, event: Event | null = null) {
    //     console.log(message)
    //     this.router.navigate([url], { state: message, replaceUrl: true })
    //         .then(data => data)
    //         .catch(e => console.log(e));
    // }


  navigateByUrl(url, message: RouteEnvelope, event: Event | null = null) {
  console.log(url, message, event);

  try {
    localStorage.setItem('routeEnvelope', JSON.stringify(message));

    const shouldReplace =
      url === ROUTE_PATH.login ||
      url === ROUTE_PATH.otp ||
      url === ROUTE_PATH.adminDashboard || url ===  ROUTE_PATH.student_profile || url === ROUTE_PATH.trainersStudentForm || url ===  ROUTE_PATH.alumniForm

    this.router.navigate([url], {
      state: message,
      replaceUrl: shouldReplace,   
      onSameUrlNavigation: 'reload'
    })
    .then(success => {
      if (!success) {
        console.warn('Navigation was prevented');
      }
    })
    .catch(error => {
      console.error('Navigation error:', error);
    });
  } catch (error) {
    console.error('Error in navigateByUrl:', error);
  }
}






    checkSmallScreen() {
        if (window.innerWidth < 1400) {
            return false;
        } else {
            return true;
        }
    }

    navigateToLogin() {
        this.clearLocalStorage();
        const envelope = new RouteEnvelope();
        envelope.type = OperationType.CREATE;
        envelope.transferData = new WidgetModel();
        this.navigateByUrl(ROUTE_PATH.login, envelope);
    }


    navigateToUploadDoc() {
        const envelope = new RouteEnvelope();
        envelope.type = OperationType.UPDATE;
        envelope.transferData = new WidgetModel();
        this.navigateByUrl(ROUTE_PATH.uploadDocument, envelope);
    }



    login(credentials, res: any = null) {
        const envelope = new RouteEnvelope();
        envelope.type = OperationType.CREATE;
        envelope.transferData = new WidgetModel();
        this.navigateByUrl(ROUTE_PATH.otp, envelope);
    }

    // navigateToProfile() {
    //     const envelope = new RouteEnvelope();
    //     envelope.type = OperationType.UPDATE;
    //     envelope.transferData = new WidgetModel();
    //     this.navigateByUrl(ROUTE_PATH.student_profile, envelope);
    // }

    navigateToProfile(type: any = USER_TYPE.student) {
        const envelope = new RouteEnvelope();
        envelope.type = OperationType.UPDATE;
        envelope.transferData = new WidgetModel();
        this.router.navigate([type === USER_TYPE.student ? ROUTE_PATH.student_profile : type === USER_TYPE.trainer ? ROUTE_PATH.trainersStudentForm : ROUTE_PATH.alumniForm], {
            state: envelope,
            // replaceUrl: true,
            onSameUrlNavigation: 'reload' // Add this to handle same-URL navigation
        })
        // this.navigateByUrl(ROUTE_PATH.student_profile, envelope);
    }

    navigateToTrainer() {
        const envelope = new RouteEnvelope();
        envelope.type = OperationType.UPDATE;
        envelope.transferData = new WidgetModel();
        this.navigateByUrl(ROUTE_PATH.trainersStudentForm, envelope);
    }

    getUserType() {
        let user = USER_TYPE.admin;
        const apiRes = JSON.parse(this.getlocalStorage('loginData'))
        if (apiRes.userType === 2 && apiRes.status === 1) {
            user = USER_TYPE.student;
        } else if (apiRes.userType === 2 && apiRes.status === 2) {
            user = USER_TYPE.inactiveStudent;
        } else if (apiRes.userType === 2 && apiRes.status === 3) {
            user = USER_TYPE.alumni;
        } else {
            user = apiRes.userType;
        }
        return user
    }



    navigateToDashboard() {
        const userRole = this.getUserRole();
        if (userRole !== 1 && userRole !== 4) {
            this.navigateToProfile();
        } else {
            const envelope = new RouteEnvelope();
            envelope.type = OperationType.VIEW;
            envelope.transferData = new GridParams();;
            this.navigateByUrl(ROUTE_PATH.adminDashboard, envelope);
        }

    }





    // verifyUserAndNavigate() {

    //     const envelope = new RouteEnvelope();
    //     envelope.type = OperationType.UPDATE;
    //     envelope.transferData = new WidgetModel();
    //     this.navigateByUrl(ROUTE_PATH.student_profile, envelope);
    // }
    getUserRole() {
        const profile = JSON.parse(this.getlocalStorage('loginData'));
        return profile.role;
    }

    convertFormData(body) {
        var formData: any = new FormData();
        Object.keys(body).forEach(a => {
            formData.append(a.toString(), body[a]);
        })
        return formData;
    }

    setLoginData(response: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.setlocalStorage('token', response['token']);
            const data = JSON.stringify(response['details']);

            // const profile = this.authService.jwtHelper.decodeToken(response['token']);
            // if (profile.role === '2' && profile.status === '4') {
            //     profile.appRole = '5'
            // } else {
            //     profile.appRole = profile.role;
            // }
            // this.setlocalStorage('profile', JSON.stringify(profile));
            const tokenDetails = this.tokenService.getDetailsFromToken(response['token']);
            // console.log(data,tokenDetails,'setLoginData');

            // console.log(tokenDetails)
            resolve(data);
        })

    }

    logout(sessionFlag = true) {
        this.logoutService.logout().then((data) => {
            console.log(data)
            this.clearLocalStorage();
            this.navigateToLogin();
        }).catch((err) => {
            console.log(err)
        })


    }

    checkLogin() {
        if (this.getlocalStorage('loginData') !== null && this.getlocalStorage('token') !== null) {
            return true;
        } else {
            return false;
        }
    }

    downloadExcel(downloadData, fields, fileName) {
        let excelModel: any = [];
        if (downloadData.length > 0) {
            if (fields.length > 0) {
                downloadData.filter(element => {
                    let obj = {};
                    fields.forEach((key: string) => {
                        obj[key['key']] = element[key['key']];
                    });
                    excelModel.push(obj);
                });
            } else {
                excelModel = downloadData;
            }
            const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelModel);
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            var wscols = [{ wch: 25 }, { wch: 25 }, { wch: 25 }, { wch: 25 }, { wch: 55 }, { wch: 75 }, { wch: 70 }];
            ws['!cols'] = wscols;
            /* save to file */
            XLSX.writeFile(wb, fileName);
        } else {
            this.showError('No Data Available to download');
        }
    }


    dateConversionPanVerify(date: string) {
        if (date.includes('/')) {
            const dobParts = date.split('/');
            const day = parseInt(dobParts[0], 10);
            const month = parseInt(dobParts[1], 10) - 1;
            const year = parseInt(dobParts[2], 10);
            const parsedDOB = new Date(year, month, day);
            const formatDob = ('0' + parsedDOB.getDate()).slice(-2) + '-' + ('0' + (parsedDOB.getMonth() + 1)).slice(-2) + '-' + parsedDOB.getFullYear();
            return formatDob;
        } else {
            const formatDob = this.dateReturnInNumber(date);
            return formatDob;
        }
    }

    dateReturnInNumber(date: string): string {
        const inputDate = new Date(date);
        const day = inputDate.getDate();
        const month = inputDate.toLocaleString('en-us', { month: '2-digit' }); // Format month as '09'
        const year = inputDate.getFullYear();
        const formattedDay = day < 10 ? '0' + day : day.toString();
        return `${formattedDay}-${month}-${year}`;
    }

    convertToDateFormat(dateString: string): string {
        if (dateString !== '') {

            const date = new Date(dateString);
            // console.log(date,dateString,'convertToDateFormat');

            if (isNaN(date.getTime())) {
                console.error('Invalid date string:', dateString);
                return '';
            }

            const year = date.getFullYear();
            const month = this.padZero(date.getMonth() + 1); // Months are zero-based
            const day = this.padZero(date.getDate());

            return `${day}-${month}-${year}`;
        }
        else {
            return '';
        }
    }

    private padZero(value: number): string {
        return value < 10 ? '0' + value : value.toString();
    }

    // mapFormValuesToPayload(form: any, payload: any): any {
    //     for (const key in payload) {
    //       if (payload.hasOwnProperty(key)) {
    //         const formValue = form[key];
    //         if (formValue !== undefined) {
    //           if (key.includes('_date')) {
    //             payload[key] = moment(formValue).format('YYYY-MM-DD HH:mm:ss');
    //           } else {
    //             payload[key] = formValue;
    //           }
    //         }
    //       }
    //     }
    //     return payload;
    //   }

    mapModelValuesToPayload(model: any, payload: any): any {
        for (const key in model) {
            if (model.hasOwnProperty(key)) {
                const modelValue = model[key];
                if (modelValue !== undefined) {
                    if (key in payload) { // Check if key exists in payload
                        if (key.includes('_date')) {
                            payload[key] = moment(modelValue).format('YYYY-MM-DD HH:mm:ss');
                        } else {
                            payload[key] = modelValue;
                        }
                    }
                }
            }
        }

        return payload;
    }


    replaceUndefinedOrNullWithEmptyString(inputObject: any): any {
        const result: any = {};

        for (const key in inputObject) {
            if (inputObject.hasOwnProperty(key)) {
                result[key] = inputObject[key] === undefined || inputObject[key] === null ? '' : inputObject[key];
            }
        }
        return result;
    }

    // removeEmptyOrNullValues(inputObject: any): any {
    //     const result: any = {};

    //     for (const key in inputObject) {
    //       if (inputObject.hasOwnProperty(key)) {
    //         const value = inputObject[key];
    //         if (value !== undefined && value !== null && value !== '') {
    //           result[key] = value;
    //         }
    //       }
    //     }
    //     return result;
    //   }



    // removeEmptyOrNullValuesAndConvertFields(inputObject: any): any {
    //     const result: any = {};
    //     const numberFields = [
    //       'age',
    //       'familyAnnualIncome',
    //       'score10',
    //       'score12',
    //       'physicsMarks',
    //       'chemistryMarks',
    //       'mathematicsMarks',
    //       'jeeScore'
    //     ];

    //     for (const key in inputObject) {
    //       if (inputObject.hasOwnProperty(key)) {
    //         let value = inputObject[key];
    //         if (value !== undefined && value !== null && value !== '') {
    //             console.log(value)
    //           if (numberFields.includes(key)) {
    //             const numValue = Number(value);
    //             value = isNaN(numValue) ? 0 : numValue;
    //           } else if (key === 'anyScholarship') {
    //             value = value === true || value === 'true' ? 1 : 0;
    //             console.log(value,'hasOwnProperty');

    //           }

    //           result[key] = value;

    //         }
    //       }
    //     }
    //     return result;
    //   }

    removeEmptyOrNullValuesAndConvertFields(inputObject: any): any {
        const result: any = {};
        const numberFields = [
            'age',
            'familyAnnualIncome',
            'score10',
            'score12',
            'physicsMarks',
            'chemistryMarks',
            'mathematicsMarks',
            'jeeScore'
        ];

        for (const key in inputObject) {
            if (inputObject.hasOwnProperty(key)) {
                let value = inputObject[key];

                if (key === 'anyScholarship' && value === '') {
                    value = 'false';
                }
                // If value is not undefined, null, or empty string, process further
                if (value !== undefined && value !== null && value !== '') {

                    // Handle case for the anyScholarship field being an empty string


                    // Handle conversion for number fields
                    if (numberFields.includes(key)) {
                        const numValue = Number(value);
                        value = isNaN(numValue) ? 0 : numValue;
                    } else if (key === 'anyScholarship') {
                        // Convert 'true' or true to 1, and anything else to 0
                        value = value === true || value === 'true' ? 1 : 0;
                    }

                    // Assign the processed value to the result
                    result[key] = value;
                }
            }
        }
        return result;
    }

    isFormData(data: any): data is FormData {
        return data instanceof FormData;
    }

    formDataToObject(formData: FormData): { [key: string]: any } {
        const obj: { [key: string]: any } = {};
        formData.forEach((value, key) => {
            // Check if the key already exists in the object
            if (obj[key] !== undefined) {
                // If it exists and is not already an array, convert it to an array
                if (!Array.isArray(obj[key])) {
                    obj[key] = [obj[key]];
                }
                // Add the new value to the array
                obj[key].push(value);
            } else {
                obj[key] = value;
            }
        });
        return obj;
    }

    async updateAlumniProfileStatus(status: boolean) {
        await this._isAlumniProfileUpdated$.next(status);
    }

    initAlumniProfileUpdateStatus() {
        const loginData = localStorage.getItem('loginData');
        if (loginData) {
            const parsed = JSON.parse(loginData);
            const isProfileUpdateRequired = parsed?.isProfileUpdateFlag === 1;
            this.updateAlumniProfileStatus(isProfileUpdateRequired);
        }
    }


    getProfile() {
        return JSON.parse(this.getlocalStorage('loginData'));
    }




}
